import {Image} from "primereact/image";

export default function UserDropdownValueTemplate(row, placeholder = false) {
    if(row) {
        return (
            <div className={'d-flex align-items-center'}>
                <Image src={'http://yii2.easytickets.pro' + row.avatar}
                       imageClassName={'img-20 rounded-circle m-r-10'}/>
                <div>
                    <div>{row.label}</div>
                </div>
            </div>
        )
    } else {
        return (<>{placeholder ? placeholder : 'Выберите сотрудника'}</>)
    }
}